import React from 'react';
import { Briefcase, TrendingUp, Users, Cpu } from 'lucide-react';

const PERSONAS = [
  {
    icon: Briefcase,
    title: 'The Strategy Builder',
    desc: 'You\u2019ve written or refined a strategy and want a platform that won\u2019t blow it up on the first volatile session.',
    points: ['Bracket-order templates', 'Per-trade risk caps', 'Symbol-level execution rules'],
  },
  {
    icon: TrendingUp,
    title: 'The Hands-Off Trader',
    desc: 'You want exposure to the markets without watching the screen. The platform runs your rules while you\u2019re away.',
    points: ['Session windows', 'Daily loss lockouts', 'Always-on kill switch'],
  },
  {
    icon: Users,
    title: 'The Multi-Account Operator',
    desc: 'You run automation across multiple accounts and need per-account isolation, audit logs, and operator-grade controls.',
    points: ['Multi-broker support', 'Per-account risk profiles', 'Immutable audit trail'],
  },
  {
    icon: Cpu,
    title: 'The Algo Engineer',
    desc: 'You care about latency, observability, and clean integration boundaries. No black boxes. No surprises.',
    points: ['Sub-second heartbeat', 'Replayable session logs', 'Clean OAuth / token model'],
  },
];

export default function BuiltFor() {
  return (
    <section className="relative border-t border-[rgba(201,162,75,0.10)]">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-5 sm:px-6 lg:px-12 py-12 lg:py-16 lg:py-24">
        <div className="max-w-3xl">
          <p className="text-[10px] tracking-[0.25em] font-mono gold-text">BUILT FOR</p>
          <h2 className="font-display mt-5 text-3xl sm:text-4xl md:text-5xl font-bold leading-[1.05] text-white">
            Trading operators,
            <br />
            <span className="gold-text">not casual day-traders.</span>
          </h2>
          <p className="mt-6 text-[#CDBE94] leading-relaxed">
            Talas is opinionated. It enforces discipline, blocks risky configurations server-side, and treats every order as an audit event. If you\u2019re looking for a casino, this isn\u2019t it.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-5">
          {PERSONAS.map((p) => {
            const Icon = p.icon;
            return (
              <div
                key={p.title}
                className="border border-white/[0.08] rounded-md p-8 bg-[#0c0c0e] hover:border-[#d8b34a]/40 transition-colors"
              >
                <div className="flex items-start gap-5">
                  <div className="w-12 h-12 border gold-border rounded-sm flex items-center justify-center shrink-0">
                    <Icon size={18} className="gold-text" strokeWidth={1.6} />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-white">{p.title}</h3>
                    <p className="mt-3 text-sm text-[#CDBE94] leading-relaxed">{p.desc}</p>
                    <div className="mt-5 pt-5 border-t border-[rgba(201,162,75,0.10)] flex flex-wrap gap-2">
                      {p.points.map((pt) => (
                        <span
                          key={pt}
                          className="text-[10px] font-mono tracking-wider text-[#CDBE94] px-2.5 py-1.5 border border-[rgba(201,162,75,0.16)] rounded-sm"
                        >
                          {pt}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
